export interface Props {
	className?: string;
	heading: string;
	feedback: string[];
	isProctorScored: boolean;
}

export function TraitFeedback(props: Props) {
	function ProctorFeedback() {
		return props.isProctorScored && props.feedback.length === 0 ? (
			<p className="italic">Your teacher has not provided any feedback.</p>
		) : (
			<p>{props.feedback[0]}</p>
		);
	}

	function GeneratedFeedback() {
		return !props.isProctorScored && props.feedback.length === 0 ? (
			<p className="italic">There was no feedback for this category.</p>
		) : (
			<ul className="ps-5">
				{props.feedback.map((feedback, index) => {
					return (
						<li key={index} className="list-disc list-outside">
							{feedback}
						</li>
					);
				})}
			</ul>
		);
	}

	return (
		<section>
			<h3 className={props.className ?? ""}>{props.heading}</h3>
			{props.isProctorScored ? <ProctorFeedback /> : <GeneratedFeedback />}
		</section>
	);
}
